import type { StatFormat } from '@/components/Stat/types'

export const statsGroupTextAligns = ['center', 'left'] as const
export type StatsGroupTextAlign = (typeof statsGroupTextAligns)[number]

export const statsGroupSizes = ['sm', 'md', 'lg', 'xl', '2xl', '3xl'] as const
export type StatsGroupSize = (typeof statsGroupSizes)[number]

export type StatsGroupArgs = {
  textAlign?: StatsGroupTextAlign
  size?: StatsGroupSize
  format?: StatFormat
}
